import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal", "form", "result", "channelSelect"]
  static values = { provider: String }

  connect() {
    // Auto-load Slack channels if provider is slack
    if (this.providerValue === "slack" && this.hasChannelSelectTarget) {
      this.loadSlackChannels()
    }
  }

  open(event) {
    event.preventDefault()
    if (this.hasModalTarget) {
      this.modalTarget.classList.remove("d-none")
    }
  }

  close(event) {
    if (event) event.preventDefault()
    if (this.hasModalTarget) {
      this.modalTarget.classList.add("d-none")
    }
  }

  async submit(event) {
    event.preventDefault()
    const form = this.hasFormTarget ? this.formTarget : event.target
    const formData = new FormData(form)

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: formData,
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Accept": "text/vnd.turbo-stream.html"
        }
      })

      if (response.ok) {
        const html = await response.text()
        if (this.hasResultTarget) {
          this.resultTarget.innerHTML = html
        }
        this.close()
      }
    } catch (error) {
      console.error("Output channel error:", error)
    }
  }

  async loadSlackChannels() {
    if (!this.hasChannelSelectTarget) return

    try {
      const response = await fetch("/connected_account_actions/slack_channels", {
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        }
      })

      if (response.ok) {
        const channels = await response.json()
        this.channelSelectTarget.innerHTML = channels.map(ch =>
          `<option value="${ch.id}">${ch.is_private ? "🔒 " : "#"}${ch.name}</option>`
        ).join("")
      }
    } catch (error) {
      console.error("Failed to load Slack channels:", error)
    }
  }
}
